var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5394 2.5C19.1232 2.5 20.6915 2.81189 22.1547 3.41797C23.618 4.02415 24.9478 4.91314 26.0677 6.0332C27.1876 7.15324 28.0761 8.48295 28.682 9.94629C29.2879 11.4095 29.6002 12.9778 29.6 14.5615L29.5853 15.1543C29.5173 16.5355 29.2114 17.8965 28.681 19.1768C28.0749 20.6398 27.1866 21.9692 26.0668 23.0889C24.9469 24.2085 23.6178 25.0972 22.1547 25.7031C20.6915 26.309 19.123 26.6203 17.5394 26.6201H5.89587L8.07166 22.8672L8.82068 21.5732L10.7933 18.1553L11.515 16.9043H17.5814C17.8925 16.9095 18.2017 16.8527 18.4906 16.7373C18.7793 16.6219 19.0423 16.4504 19.264 16.2324C19.4859 16.0143 19.6623 15.7538 19.7826 15.4668C19.9028 15.1799 19.9642 14.8716 19.9642 14.5605C19.9642 14.2495 19.9028 13.9412 19.7826 13.6543C19.6623 13.3675 19.4858 13.1077 19.264 12.8896C19.0423 12.6715 18.7794 12.4992 18.4906 12.3838C18.2017 12.2684 17.8925 12.2116 17.5814 12.2168H11.4633L10.7416 10.9668L8.81873 7.6377L8.01794 6.24902L5.85388 2.5H17.5394Z",
    fill: "url(#paint0_linear_8217_71420)",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92673 6.95117L11.0644 8.91602L11.0654 8.91797L13.8818 13.7969L14.0957 14.168L14.0859 14.4561L14.1523 14.8506L13.8828 15.3174L11.1181 20.1064L9.92575 22.168L9.17575 23.4668L7.87692 22.7168L3.34958 20.1016L2.05075 19.3516L2.80075 18.0527L4.81833 14.5576L2.80075 11.0625L2.04977 9.7627L3.35056 9.0127L7.87985 6.40332L9.17673 5.65625L9.92673 6.95117Z",
    fill: "url(#paint1_linear_8217_71420)",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8217_71420",
    x1: 10.183,
    y1: 14.5601,
    x2: 27.0995,
    y2: 14.5601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B75C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8217_71420",
    x1: 4.09958,
    y1: 14.5577,
    x2: 12.5842,
    y2: 14.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85D31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpLogo);
export default __webpack_public_path__ + "static/media/sharpLogo.e3d39815f20c3aac465d472b6fe42271.svg";
export { ForwardRef as ReactComponent };